import {withLeadingSlash, withoutLeadingSlash, withoutTrailingSlash} from "ufo";

export function limitPathDepth(path: string, maxDepth: number): string {
  const segments = path.split("/"); // Split path by "/"
  const limitedSegments = segments.slice(0, maxDepth + 1); // Limit to maxDepth
  return limitedSegments.join("/"); // Rejoin into a path
}

export function getPathDepth(path: string): number {
  const normalizedPath = withLeadingSlash(withoutTrailingSlash(path));
  const result =
    normalizedPath && normalizedPath.length < 2
      ? 0
      : normalizedPath.split("/").length - 1;
  return result;
}
